export const restockBinSources = ["shiphero", "wms"] as const;

export type RestockBinSource = (typeof restockBinSources)[number];
export const RestockBinSource = restockBinSources;
